import { Base } from '@studiometa/js-toolkit';

/**
 * Panel Class.
 */
export default class LanguageModal extends Base {
  isOpen = false;

  static config = {
    name: 'LanguageModal',
    refs: ['close[]', 'panel'],
  };

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.close();
    }
  }

  /**
   * Close on click
   * @returns {void}
   */
  onCloseClick() {
    this.close();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  open() {
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');
    this.$el.classList.remove('pointer-events-none', 'opacity-0');
    this.$refs.panel.classList.remove('translate-y-20', 'opacity-0');
  }

  /**
   * Close popin
   * @returns {void}
   */
  close() {
    this.isOpen = false;
    document.body.classList.remove('overflow-hidden');
    this.$refs.panel.classList.add('translate-y-20', 'opacity-0');
    this.$el.classList.add('pointer-events-none', 'opacity-0');
  }
}
